
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA en Nouvelle-Aquitaine dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads en Nouvelle-Aquitaine certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité sur Google et générer plus de prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads en Nouvelle-Aquitaine dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads en Nouvelle-Aquitaine certifiée Google Partner, accompagne les entreprises régionales pour accroître leur visibilité sur Google et générer plus de prospects qualifiés.",
        },
      ],
    };
  },
};
